'use client';

import { useEffect, useState } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { aiUsageApi } from '../_lib/api';

export default function AdminDlqPage() {
  const { t } = useTranslation();
  const tt = t.aiUsage;
  const [reason, setReason] = useState<string>('');
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    aiUsageApi.listDlq({ reason, page: 1, pageSize: 100 })
      .then((res) => setItems(res.items))
      .finally(() => setLoading(false));
  }, [reason]);

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-semibold mb-6">{tt.nav.dlq}</h1>

      <div className="flex gap-2 mb-4 text-sm">
        {(['', 'BAD_FORMAT', 'TS_OUT_OF_WINDOW', 'BLOCKED_DEVICE', 'OVER_LIMIT'] as const).map((r) => (
          <button
            key={r}
            onClick={() => setReason(r)}
            className={`px-3 py-1 rounded text-xs ${reason === r ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}
          >
            {r || 'All'}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-sm text-gray-500">Loading…</div>
      ) : (
        <div className="bg-white rounded shadow overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="text-gray-500 border-b">
              <tr>
                <th className="py-3 px-4 text-left">Time</th>
                <th className="py-3 px-4 text-left">Reason</th>
                <th className="py-3 px-4 text-left">Device</th>
                <th className="py-3 px-4 text-left">Payload preview</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id} className="border-b">
                  <td className="py-2 px-4 text-gray-500">{new Date(row.createdAt).toLocaleString()}</td>
                  <td className="py-2 px-4">
                    <span className="px-2 py-0.5 bg-red-100 text-red-700 rounded">{row.reason}</span>
                  </td>
                  <td className="py-2 px-4 font-mono">{row.deviceId?.slice(0, 8) ?? '-'}</td>
                  <td className="py-2 px-4 font-mono text-xs truncate max-w-xl">
                    {JSON.stringify(row.rawPayload).slice(0, 200)}…
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={4} className="py-8 text-center text-gray-400">No DLQ entries</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
